import Vue from "vue";
import Vuex from "vuex";
import main from "./main";
import sideMenu from "./side-menu";
import simpleMenu from "./simple-menu";
import sideMenuFront from "./side-menu-front";
import topMenu from "./top-menu";
import topMenuFront from "./top-menu-front";
import auth from "./auth";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    main: main,
    sideMenu: sideMenu,
    simpleMenu: simpleMenu,
    sideMenuFront: sideMenuFront,
    topMenu: topMenu,
    topMenuFront: topMenuFront,
    auth: auth
  }
});
